module.exports = __webpack_public_path__ + "img/5-3.1c0886bc.svg";